import { call, all, put, takeLatest } from "redux-saga/effects";
import { authHeader } from "../../../utils";
import request from "../../../services/request";
import * as ActionTypes from "../../actions/constants/types";
import { setLocaleSuccess, setLocaleError } from "../../actions/universe";

function* localeSaga() {
  try {
    const requestURL = "/universe";
    const response = yield call(request, {
      url: requestURL,
      method: "GET",
      headers: {
        Authorization: authHeader(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    yield put(setLocaleSuccess(response));
  } catch (error) {
    if (
      typeof error !== "undefined" &&
      typeof error.data !== "undefined" &&
      typeof error.data.error !== "undefined" &&
      typeof error.data.error.message !== "undefined"
    ) {
      yield put(setLocaleError(error));
    }
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(ActionTypes.LOCALE, localeSaga)]);
}
